import { exportTenant, getExportTenantFileName } from '../../sources/tenant';
import translations from '../../translations';
import { activateFileDownload } from '../../utils/file';
import ButtonPrimary from '../buttons/ButtonPrimary';
import { useNotificationDispatch } from '../notifications/NotificationProvider';

interface ExportTenantProps {
    tenantName: string;
}

const ExportTenant = ({ tenantName }: ExportTenantProps) => {
    const dispatchNotification = useNotificationDispatch();

    const onClick = async () => {
        try {
            const blob = await exportTenant();
            activateFileDownload(blob, getExportTenantFileName(tenantName));
        } catch (error) {
            dispatchNotification({
                type: 'notifyError',
                payload: {
                    error,
                },
            });
        }
    };

    return (
        <>
            <p>{translations.IMPORT_EXPORT_export_help_text}</p>
            <ButtonPrimary onClick={onClick}>
                {translations.IMPORT_EXPORT_export_button_label}
            </ButtonPrimary>
        </>
    );
};

export default ExportTenant;
